{
  "title": "Lista de Seguimiento",
  "header": {
    "collapse": "Contraer",
    "expand": "Expandir",
    "approaching_one": "{{count}} acercándose",
    "approaching_other": "{{count}} acercándose",
    "thresholdSummary": "Cuentas dentro del {{percent}}% del umbral de desviación — monitorear, no se requiere ninguna acción hoy"
  },
  "table": {
    "portfolio": "Cartera",
    "accountType": "Tipo de cuenta",
    "reason": "Motivo",
    "custodian": "Custodio",
    "value": "Valor",
    "bandConsumed": "Banda consumida",
    "threshold": "Umbral"
  },
  "empty": {
    "title": "Ninguna cuenta se acerca al umbral."
  },
  "footer": {
    "configure": "Configurar",
    "rowCount_one": "Mostrando {{count}} cuenta",
    "rowCount_other": "Mostrando {{count}} cuentas",
    "threshold": "Umbral: {{percent}}% de banda consumida"
  },
  "triggers": {
    "cashDeposit": "Depósito en efectivo",
    "extTransfer": "Transferencia externa",
    "sectorConcentration": "Concentración sectorial",
    "dividendReinvestment": "Reinversión de dividendos"
  }
}
